import { render } from "./PosRapport.vue?vue&type=template&id=b47730aa&scoped=true&ts=true"
import script from "./PosRapport.vue?vue&type=script&lang=ts"
export * from "./PosRapport.vue?vue&type=script&lang=ts"

import "./PosRapport.vue?vue&type=style&index=0&id=b47730aa&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b47730aa"]])

export default __exports__